export const ACCOUNT_FIELD = "account";
export const BUSINESS_ID_FIELD = "businessId";
export const SPECIAL_SERVICE_EXCLUSIONS_FIELD = "specialServices";
export const CUSTOMER_SETTINGS_ERRORS = {
  [BUSINESS_ID_FIELD]: "No users with this logon ID found",
  ACCOUNT_WAS_NOT_FOUND: "Account was not found",
  ACCOUNT_WAS_NOT_FOUND_FOR_DPD: 'Account was not found for business ID "DPD" ',
  ACCOUNT_WAS_NOT_FOUND_FOR_DPD_LOCAL:
    'Account was not found for business ID "DPD LOCAL" ',
};
export const SEARCH_FORM_ERRORS = {
  MISSING_ACCOUNT: "Please enter logon ID or account",
};
